"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pavullo-nel-frignano": {
    "dd41e464": [{
      "hkey": "91b0553d",
      "slug": "gaiato-pozzaccia",
      "name": "Gaiato-Pozzaccia",
      "primary": true,
      "skipSearch": false
    }],
    "gaiato": [{
      "hkey": "91b0553d",
      "slug": "gaiato-pozzaccia",
      "name": "Gaiato-Pozzaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "84fd94ea": [{
      "hkey": "575ae90e",
      "slug": "pavullo-nel-frignano",
      "name": "Pavullo nel Frignano",
      "primary": true,
      "skipSearch": false
    }],
    "iddiano": [{
      "hkey": "575ae90e",
      "slug": "pavullo-nel-frignano",
      "name": "Pavullo nel Frignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81cae521": [{
      "hkey": "575ae90e",
      "slug": "pavullo-nel-frignano",
      "name": "Pavullo nel Frignano",
      "primary": true,
      "skipSearch": false
    }],
    "montorso": [{
      "hkey": "575ae90e",
      "slug": "pavullo-nel-frignano",
      "name": "Pavullo nel Frignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c62f46f8": [{
      "hkey": "5ca3a7f6",
      "slug": "sassoguidano-niviano",
      "name": "Sassoguidano-Niviano",
      "primary": true,
      "skipSearch": false
    }],
    "niviano": [{
      "hkey": "5ca3a7f6",
      "slug": "sassoguidano-niviano",
      "name": "Sassoguidano-Niviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pavullo-nel-frignano"
    }],
    "666b8aac": [{
      "hkey": "2b9a5139",
      "slug": "piantacroce-renno",
      "name": "Piantacroce-Renno",
      "primary": true,
      "skipSearch": false
    }],
    "renno": [{
      "hkey": "2b9a5139",
      "slug": "piantacroce-renno",
      "name": "Piantacroce-Renno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "42a2a25a": [{
      "hkey": "5ca3a7f6",
      "slug": "sassoguidano-niviano",
      "name": "Sassoguidano-Niviano",
      "primary": true,
      "skipSearch": false
    }],
    "sassoguidano": [{
      "hkey": "5ca3a7f6",
      "slug": "sassoguidano-niviano",
      "name": "Sassoguidano-Niviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;